<template>
    <b-modal
      v-if="currentLssa != null"
      :visible="visible"
      @hidden="hide"       
      @change="change"
      scrollable
      ref="modal_line_details"
      id="modal-line-details"
      no-close-on-backdrop      
      :title="$t('lssa.title')"
      :ok-only="true" 
      :ok-title="$t('close')" 
    >
    
     <!-- scheda descrittiva in alto -->
    <!-- | foto | Product | id | -->
    <b-row>
      <b-col cols="12" sm="4">
        <img v-if="currentLssa.product_image" class="ml-4" :src="pathDeviceImages + currentLssa.product_image"
          style="height:80px; width:auto; float: left; margin-right: 10px" />
        <img v-else :src="'/img/emergency.jpg'" style="height:auto; width:80px;" />
      </b-col>
      <b-col v-if="currentLssa.product_desc" cols="8" offset="1" offset-sm="0" sm="5">
        <b-row>
          <b-col>
            {{ $t("details_lamp.lamp_prod_desc") }}
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <strong>
              {{currentLssa.product_desc }}
            </strong>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3" sm="3">
        <b-row v-if="currentLssa.index!='97'">
          <b-col>{{ $t("lssa.address") }}
          </b-col>
        </b-row>
        <b-row v-if="currentLssa.index!='97'">
          <b-col>
            <strong>{{currentLssa.index}}</strong>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <!-- | - | description | button modifica |  -->
    <b-row class="mt-2">
      <!-- <b-col cols="11" offset="1" sm="8" offset-sm="4"> -->
      <b-col cols="8" offset="1" offset-sm="4" sm="6">
        <b-row><b-col>{{$t("details_cu_modal.cu_descrizione")}}</b-col></b-row>
        <b-row>
          <b-col v-if="!editingLssaLocal" cols="8">
            <strong>{{currentLssa.module_description ? currentLssa.module_description: nomeLssa}}</strong>
          </b-col>
          <b-col v-if="!editingLssaLocal" cols="4" sm="2">
            <b-button @click="editNomeLssa" :aria-label="$t('lssa.modify_name')">
              <i class="fa fa-edit"></i>
            </b-button>
          </b-col>
          <!-- <b-col v-if="editingLssaLocal" cols="8">
            <div role="group">
            <b-form-input id="lssaName" type="text" v-model="nomeLssa"></b-form-input>
            <b-form-text v-html="lssaNameInfo"></b-form-text>
            </div>
          </b-col> -->
          <b-col v-if="editingLssaLocal" cols="8">
            <b-form-group label-for="lssaName" :description="lssaNameInfo">
              <b-form-input
                id="lssaName"
                type="text"
                v-model="nomeLssa"
                placeholder="Inserisci nome LSSA"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col v-if="editingLssaLocal" cols="4">
            <b-button-group v-if="!updatingNameLocal">
              <b-button @click="saveNomeLssa" :aria-label="$t('save')">
                <i class="fa fa-check"></i>
              </b-button>
              <b-button @click="abortNomeLssa" :aria-label="$t('cancel')">
                <i class="fa fa-close"></i>
              </b-button>
            </b-button-group>
            <span v-else>
              <i class="fa fa-spinner fa-spin"></i>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="11" offset="1" sm="8" offset-sm="4">
        <!-- pdf -->
        <b-row>
          <b-col
            v-if="currentLssa.product_pdf != null && currentLssa.product_pdf != 'undefined' && currentLssa.product_pdf != ''">
            {{ $t("details_lamp.lamp_pdf") }}</b-col>
        </b-row>
        <b-row>
          <b-col
            v-if="currentLssa.product_pdf != null && currentLssa.product_pdf != 'undefined' && currentLssa.product_pdf != ''">
            <a :href="currentLssa.product_pdf.includes('|') ? pathDevicePdf + currentLssa.product_pdf.split('|')[0] : pathDevicePdf + currentLssa.product_pdf"
              target="_blank">
              <span class="mr-1"><i class="fa fa-file" style="color:#009DE0"></i></span>
              {{ currentLssa.product_pdf.includes("|") ? currentLssa.product_pdf.split("|")[0] : currentLssa.product_pdf }}
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <hr>

    <!-- Details -->
      <b-row class="m-2"><b-col sm="12"><strong>{{ $t("details_lamp.lamp_details") }}</strong></b-col></b-row>
      <b-row
        v-if="currentLssa.product_code != '' && currentLssa.product_code != null && !currentLssa.product_desc.includes('|')"
        class="m-2"><b-col cols="6" sm="5">{{ $t("details_lamp.lamp_code") }} :</b-col><b-col cols="6" sm="4">
          {{currentLssa.product_code }}</b-col></b-row>
      <b-row
        v-if="currentLssa.product_code != '' && currentLssa.product_code != null && currentLssa.product_desc.includes('|')"
        class="m-2"><b-col cols="6" sm="5">{{ $t("details_lamp.lamp_code") }} :</b-col><b-col cols="6" sm="4">
          {{currentLssa.product_code.split('|')[0] }}</b-col></b-row>
      <b-row v-if="currentLssa.order_code != '' && currentLssa.order_code != null" class="m-2"><b-col cols="6"
          sm="5">{{ $t("details_lamp.lamp_order_code") }} :</b-col><b-col cols="6" sm="4">
            {{ currentLssa.order_code}}</b-col></b-row>

    </b-modal>
</template>

<script>
// import Vue from 'vue'

export default {
  name: "LssaDetails",
  model: {
    prop: "visible",
    event: "change"
  },
  props: {
    currentLssa: null,
    scanning: false,
    visible: {
      type: Boolean,
      default: false
    },
    editingLssa: false,
    updateFinito: true
  },

  emits:['hide', 'change', 'editing-lssa', 'updating-lssa'],

  data() {
    return {
        pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,                 //pathDeviceImages for DEV : "https://d7e8bp38d6h8e.cloudfront.net/",
        pathDevicePdf: process.env.VUE_APP_PATH_DEVICE_PDF,                       //pathDevicePdf for DEV : "https://d1y7ruw82jsjj9.cloudfront.net/",
        isVisible: false, //*
        nomeLssa: '',
    };
  },

  computed: {
    lssaNameInfo() {
        const nc = this.nomeLssa.length ? this.nomeLssa.length : 0;
        const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeCent);
        if (!validChars) return "<b style=\"color:red\">Sono presenti caratteri non ammessi</b>";
        if (nc > 30 || !validChars) {
            return "<b style=\"color:red\">" + nc + "/30 Caratteri</b>";
        }
        return "" + nc +"/30 Caratteri";
    },
    updatingNameLocal() {
        return !this.updateFinito;
    },
    //computed property associata alla prop 'editingCent' per gestire la bidirezionalità:
    //legge editingLssa (get)
    //emette l'evento 'editing' al padre quando viene modificata (set)
    editingLssaLocal: {
      get: function() {
        return this.editingLssa;
      },
      set: function(value) {
        console.log("MODAL set editingLssaLocal ", value)
        this.$emit('editing-lssa', { editingLssa: value});
      }
    },
  },

  created() {
  },
  mounted() {
  },

  methods: {
    //abilita l'input per cambiare il nome della Centrale
    editNomeLssa() {
        this.nomeLssa = this.currentLssa.module_description;
        this.editingLssaLocal = true;
        console.log("MODAL editingLssaLocal ", this.editingLssaLocal)
    },

    abortNomeLssa() {
        this.editingLssaLocal = false;
    },
    //esegue il cambio del nome, incaricando lo store di aggiornare il database
    saveNomeLssa() {
        const validChars = /^[\p{L}\p{N}\s]*$/u.test(this.nomeLssa);
        if (!validChars) {
            this.$bvModal.msgBoxOk("La descrizione del Lssa contiene caratteri non validi");
            return;
        }

        if (this.nomeCent.length > 30) {
            this.$bvModal.msgBoxOk("La descrizione della centrale non può superare i 30 caratteri");
            return;
        }
    
        this.$store.dispatch('sendCablecomCommand', {cu_command: 'setCuName',cu_type: this.currentCent.cu_type, cu_id: this.currentCent.cu_id, cuName: this.nomeCent});
        this.$emit('updating-lssa', { nomeLssa: this.nomeLssa, updatingName: true});
        console.log("MODAL updatingName = ", this.updatingNameLocal)
    },
    //cerca nelle properties dell'oggetto disp, isola quelle che contengono 'error' e verifica se il valore è ON
    NessunErrore(disp) {
        let noerrore = true
        for (const property in disp)
        {
            if ((property.includes("error")) && (disp[property] === "ON"))
            {
                noerrore = false;
            }
        }
        return noerrore;     
    },

    //si attiva con l'evento 'change' ed emette verso il padre un evento 'change'
    change(visible) {
        // console.log("MASSI01: change visible", visible)
        this.$emit("change", visible);
    },
    //si attiva con l'evento 'hide' ed emette verso il padre un evento 'hide'
    hide() {
        // console.log("MASSI02: emesso hide")
         this.$emit("hide");
    },

  }
}
</script>

<style>
</style>